import axios from 'axios';
import { endSession } from './session';
import { persistCanRespondToIncidents } from '../lib/incidentAccess';

// ✅ Автоматически подставит '/api' из .env или по умолчанию
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  withCredentials: true,
});

// ✅ Добавление accessToken из localStorage
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Обработка 401: попытка обновить токен и повторить запрос
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Исключаем запросы обновления пароля из автоматической обработки 401
    // чтобы не разлогинивать пользователя при неверном текущем пароле
    const isPasswordUpdate = originalRequest?.url?.includes('/update-password');

    // Сам запрос обновления токена не должен обновляться повторно — иначе
    // мёртвый refresh-токен уводит перехватчик в бесконечную рекурсию.
    const isRefresh = originalRequest?.url?.includes('/refresh-token');

    if (error.response && error.response.status === 401 && !originalRequest._retry && !isPasswordUpdate && !isRefresh) {
      originalRequest._retry = true;

      try {
        const refreshRes = await instance.post('/refresh-token', {}, {
          withCredentials: true,
        });

        const newAccessToken = refreshRes.data.accessToken;
        localStorage.setItem('authToken', newAccessToken);
        if (typeof refreshRes.data.canRespondToIncidents === 'boolean') {
          persistCanRespondToIncidents(refreshRes.data.canRespondToIncidents);
        }
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

        return instance(originalRequest);
      } catch (refreshErr) {
        endSession();
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
